import React,  {useState, useEffect, useRef, useCallback, forwardRef} from 'react';
import NovelCovid from 'novelcovid';
import InfiniteScroll from 'react-infinite-scroller';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import clsx from 'clsx';
import { Link } from 'react-router-dom';
//import {Helmet} from "react-helmet";
import HomeIcon from '@material-ui/icons/Home';
import DnsRoundedIcon from '@material-ui/icons/DnsRounded';
import PublicIcon from '@material-ui/icons/Public';
import styles from '../../utils/navigationStyle';
import { makeStyles } from '@material-ui/core/styles';

import { Icon } from "@material-ui/core";

import LinkTo from '../../utils/LinkTo';

import Avatar from '@material-ui/core/Avatar';

import { NavLink as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';



const useStyles = makeStyles(theme => ({
  ...styles,
  small: {
    width: theme.spacing(2.1),
    height: theme.spacing(2.1),
    
  },
}))


const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const AllCountriesNavigation = (props) => {
const { handleSidebarClose } = props;

const allCountriesRedux = useSelector(state => state.data.countries);
const classes = useStyles();

const loadFunc = () => {
  return true;
}


  return (
     <React.Fragment>
     <InfiniteScroll
        pageStart={0}
        loadMore={loadFunc}
        hasMore={true}
        loader={<div className="loader" key={0}></div>}
        useWindow={false}
    >
        
        {allCountriesRedux.map(({country, countryInfo: {flag}}) => (
             <React.Fragment>
             <LinkTo handleSidebarClose={handleSidebarClose} activeClassName={classes.itemActiveItem} to={`/covid19/country/${country}`} >
              <ListItem
                key={country}
                button
                className={clsx(classes.item   )}
              >
                <ListItemIcon className={classes.itemIcon}>       
                       <Avatar className={classes.small} src={flag} />    
                </ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  {country}
                </ListItemText>
              </ListItem>
              </LinkTo>
              </React.Fragment>
            ))}
    </InfiniteScroll>

     
      </React.Fragment>
  );
}

export default AllCountriesNavigation;
